import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import axios from 'axios';
import StockTable from './StockTable';
import BeatLoader from 'react-spinners/BeatLoader';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`shop-tabpanel-${index}`}
      aria-labelledby={`shop-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function StockAllocation() {
  const [tabIndex, setTabIndex] = useState(0);
  const [shop1Stock, setShop1Stock] = useState([]);
  const [shop2Stock, setShop2Stock] = useState([]);
  const [shop3Stock, setShop3Stock] = useState([]);
  const [shop4Stock, setShop4Stock] = useState([]);
  const [storeStock, setStoreStock] = useState([]);

  const [loading, setLoading] = useState(false);

  const [shop1SearchTerm, setShop1SearchTerm] = useState('');
  const [shop2SearchTerm, setShop2SearchTerm] = useState('');
  const [shop3SearchTerm, setShop3SearchTerm] = useState('');
  const [shop4SearchTerm, setShop4SearchTerm] = useState('');

  const [selectedItem, setSelectedItem] = useState(null);
  const [allocationQty, setAllocationQty] = useState('');
  const [targetShop, setTargetShop] = useState('');

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  // States for Return Modal
  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [returnSelectedItem, setReturnSelectedItem] = useState(null);
  const [returnLoading, setReturnLoading] = useState(false);

  // States for Edit Modal
  const [EditModalOpen, setEditModalOpen] = useState(false);
  const [EditSelectedItem, setEditSelectedItem] = useState(null);
  const [EditLoading, setEditLoading] = useState(false);
  const [editQty, seteditQty] = useState(1); // Quantity to return


    // New States for Return Modal Enhancements
    const [suppliers, setSuppliers] = useState([]); // List of suppliers
    const [selectedSupplier, setSelectedSupplier] = useState(''); // Selected supplier
    const [returnQty, setReturnQty] = useState(1); // Quantity to return
    const [unitPrice, setUnitPrice] = useState(0); // Unit price of the item
    const [totalReturn, setTotalReturn] = useState(0); // Total value of the return

  useEffect(() => {
    fetchStockData();
  }, []);


    // Handle Selling Price Change with Validation
    const handleSellingPriceChange = (e) => {
      let price = parseFloat(e.target.value);
      if (isNaN(price)) {
        price = 0;
      } else {
        // Ensure price is within the valid range
        if (price < 0) price = 0;
      }
      setUnitPrice(price);
      setTotalReturn(price * returnQty);
    };


  const fetchSuppliers = async () => {
    try {
      // Replace with your actual API endpoint for fetching suppliers
      const response = await axios.get('https://serverfourpaws.ccsoftwares.com/suppliers/getSuppliers');
      console.log(response.data);
      setSuppliers(response.data);
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to fetch suppliers.');
      setAlertOpen(true);
    }
  };

  const fetchStockData = async () => {
    try {
      const [
        shop1Response,
        shop2Response,
        shop3Response,
        shop4Response,
        storeStockResponse,
      ] = await Promise.all([
        axios.get('https://serverfourpaws.ccsoftwares.com/stock/getShop1Stock'),
        axios.get('https://serverfourpaws.ccsoftwares.com/stock/getShop2Stock'),
        axios.get('https://serverfourpaws.ccsoftwares.com/stock/getShop3Stock'),
        axios.get('https://serverfourpaws.ccsoftwares.com/stock/getShop4Stock'),
        axios.get('https://serverfourpaws.ccsoftwares.com/stock/getStoreStock'),
      ]);

      setShop1Stock(shop1Response.data);
      setShop2Stock(shop2Response.data);
      setShop3Stock(shop3Response.data);
      setShop4Stock(shop4Response.data);
      setStoreStock(storeStockResponse.data);
    } catch (error) {
      console.error('Error fetching stock data:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to fetch stock data.');
      setAlertOpen(true);
    }
  };


  const fetchUnitPrice = async () => {
    if (!returnSelectedItem) return;


    try {
      // Replace with your actual API endpoint for fetching unit price

      const data = {
        itemid : returnSelectedItem.itemid
      }

      console.log(data);
      const response = await axios.post(
        `https://serverfourpaws.ccsoftwares.com/Item/getUnitPrice`,data
      );
      console.log(response.data[0].sellingPrice);
      setUnitPrice(response.data[0].sellingPrice);
      setTotalReturn(response.data[0].sellingPrice * returnQty);
    } catch (error) {
      console.error('Error fetching unit price:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to fetch unit price.');
      setAlertOpen(true);
    }
  };


  useEffect(() => {
    if (returnModalOpen) {
      fetchSuppliers();
      fetchUnitPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [returnModalOpen]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleAllocation = async () => {
    if (!selectedItem || !allocationQty || !targetShop) {
      setAlertSeverity('warning');
      setAlertMessage('Please select item, quantity, and target shop.');
      setAlertOpen(true);
      return;
    }

    const allocationData = {
      targetShop: targetShop,
      itemName: selectedItem.itemname,
      expirationDate: selectedItem.stockexpiredate,
      qty: parseInt(allocationQty),
    };

    try {
      setLoading(true);
      await axios.post(`https://serverfourpaws.ccsoftwares.com/stock/stockAllocation`, allocationData);

      // Refresh stock data
      await fetchStockData();
      setLoading(false);

      // Reset form fields
      setSelectedItem(null);
      setAllocationQty('');
      setTargetShop('');

      setAlertSeverity('success');
      setAlertMessage('Stock allocated successfully.');
      setAlertOpen(true);
    } catch (error) {
      console.error('Error allocating stock:', error);
      setAlertSeverity('error');
      setAlertMessage('Error allocating stock.');
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const handleAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  const handleEditClick = (item) => {
    console.log(item)
    setEditModalOpen(true);
    setEditSelectedItem(item);


  }

 
  // Handle Return Modal Close
  const handleReturnClick = (item) => {
    setReturnSelectedItem(item);
    setReturnModalOpen(true);
    setSelectedSupplier('');
    setReturnQty(1);
    setUnitPrice(0);
    setTotalReturn(0);
  };

  const handleReturnModalClose = () => {
    setReturnModalOpen(false);
    setReturnSelectedItem(null);
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
    setEditSelectedItem(null);
    seteditQty(0)
  };


  const handleReturnQtyChange = (e) => {
    let qty = parseInt(e.target.value);
    if (isNaN(qty)) {
      qty = '';
    } else {
      // Ensure qty is within the valid range
      if (qty < 1) qty = 1;
      if (qty > returnSelectedItem.stock) qty = returnSelectedItem.stock;
    }
    setReturnQty(qty);
    setTotalReturn(unitPrice * qty);
  };


  const handleEditQtyChange = (e) => {

    seteditQty(e.target.value)
 
  };


  const handleConfirmEdit = async () => {
   
    console.log(EditSelectedItem)

    if (!editQty ) {
      setAlertSeverity('warning');
      setAlertMessage('Please enter a valid quantity to return.');
      setAlertOpen(true);
      return;
    }

    const returnData = {
      stockId : EditSelectedItem.stockId,
      returnqty: editQty
    };

    try {
      setEditLoading(true);
      console.log(returnData)
      await axios.post('https://serverfourpaws.ccsoftwares.com/stock/editStock', returnData);

      // Refresh stock data
      await fetchStockData();
      setEditLoading(false);

      setAlertSeverity('success');
      setAlertMessage('Stock returned successfully.');
      setAlertOpen(true);

      // Close the modal
      handleEditModalClose();
    } catch (error) {
      console.error('Error returning stock:', error);
      setAlertSeverity('error');
      setAlertMessage('Error returning stock.');
      setAlertOpen(true);
      setEditLoading(false);
    }
  };



  const handleConfirmReturn = async () => {
    if (!returnSelectedItem) {
      setAlertSeverity('warning');
      setAlertMessage('No item selected for return.');
      setAlertOpen(true);
      return;
    }

    if (!selectedSupplier) {
      setAlertSeverity('warning');
      setAlertMessage('Please select a supplier.');
      setAlertOpen(true);
      return;
    }

    if (!returnQty || returnQty < 1 || returnQty > returnSelectedItem.stock) {
      setAlertSeverity('warning');
      setAlertMessage('Please enter a valid quantity to return.');
      setAlertOpen(true);
      return;
    }

    const returnData = {
      stockId : returnSelectedItem.stockId,
      itemName: returnSelectedItem.itemname,
      itemId: returnSelectedItem.itemid,
      ReturnUnitPrice: unitPrice,
      returnqty: returnQty,
      returnValue: totalReturn, // Include the total return value
      expirationDate: returnSelectedItem.stockexpiredate,
      SupplierId: selectedSupplier,
      returndate: new Date().toISOString().split('T')[0]
    };

    try {
      setReturnLoading(true);
      console.log(returnData)
      await axios.post('https://serverfourpaws.ccsoftwares.com/stock/returnSupplier', returnData);

      // Refresh stock data
      await fetchStockData();
      setReturnLoading(false);

      setAlertSeverity('success');
      setAlertMessage('Stock returned successfully.');
      setAlertOpen(true);

      // Close the modal
      handleReturnModalClose();
    } catch (error) {
      console.error('Error returning stock:', error);
      setAlertSeverity('error');
      setAlertMessage('Error returning stock.');
      setAlertOpen(true);
      setReturnLoading(false);
    }
  };



  // Filter functions for each shop
  const filterStockData = (stockData, searchTerm) => {
    return stockData.filter((item) =>
      item.itemname.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <Box sx={{ width: '100%', paddingTop: '50px' }}>
      <Tabs value={tabIndex} onChange={handleTabChange} centered>
        <Tab label="Main Store" />
        <Tab label="Kalawana Shop" />
        <Tab label="Pelmadulla Shop" />
        <Tab label="Ratnapura Shop" />
        <Tab label="Allocate Stock" />
      </Tabs>

      {/* Main Store Stock */}
      <TabPanel value={tabIndex} index={0}>
        <Typography variant="h6">Main Store Stock</Typography>
        <TextField
          label="Search Item"
          variant="outlined"
          fullWidth
          sx={{ mt: 2, mb: 2 }}
          value={shop1SearchTerm}
          onChange={(e) => setShop1SearchTerm(e.target.value)}
        />
        <StockTable
          stockData={filterStockData(storeStock, shop1SearchTerm)}
          onReturn={handleReturnClick} // Pass the handler
          onEdit={handleEditClick}
        />
      </TabPanel>

      {/* Kalawana Shop Stock */}
      <TabPanel value={tabIndex} index={1}>
        <Typography variant="h6">Kalawana Stock</Typography>
        <TextField
          label="Search Item"
          variant="outlined"
          fullWidth
          sx={{ mt: 2, mb: 2 }}
          value={shop2SearchTerm}
          onChange={(e) => setShop2SearchTerm(e.target.value)}
        />
        <StockTable stockData={filterStockData(shop2Stock, shop2SearchTerm)} />
      </TabPanel>

      {/* Pelmadulla Shop Stock */}
      <TabPanel value={tabIndex} index={2}>
        <Typography variant="h6">Pelmadulla Stock</Typography>
        <TextField
          label="Search Item"
          variant="outlined"
          fullWidth
          sx={{ mt: 2, mb: 2 }}
          value={shop3SearchTerm}
          onChange={(e) => setShop3SearchTerm(e.target.value)}
        />
        <StockTable stockData={filterStockData(shop3Stock, shop3SearchTerm)} />
      </TabPanel>

      {/* Ratnapura Shop Stock */}
      <TabPanel value={tabIndex} index={3}>
        <Typography variant="h6">Ratnapura Stock</Typography>
        <TextField
          label="Search Item"
          variant="outlined"
          fullWidth
          sx={{ mt: 2, mb: 2 }}
          value={shop4SearchTerm}
          onChange={(e) => setShop4SearchTerm(e.target.value)}
        />
        <StockTable stockData={filterStockData(shop4Stock, shop4SearchTerm)} />
      </TabPanel>

      {/* Allocate Stock */}
      <TabPanel value={tabIndex} index={4}>
        <Typography variant="h6">Allocate Stock from Main Store</Typography>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={shop1Stock}
                getOptionLabel={(option) => `${option.itemname} (${option.itemid})`}
                onChange={(event, newValue) => {
                  setSelectedItem(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="Item" />}
                filterOptions={(options, { inputValue }) =>
                  options.filter(
                    (option) =>
                      option.itemname.toLowerCase().includes(inputValue.toLowerCase()) ||
                      option.itemid.toString().toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderOption={(props, option) => (
                  <li {...props}>
                    <span style={{ fontWeight: 'bold' }}>{option.itemname}</span> | EXP:{' '}
                    {option.stockexpiredate === '2100-12-31' ? 'No' : option.stockexpiredate} | Avl:{' '}
                    {option.stock}
                  </li>
                )}
                value={selectedItem}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Quantity"
              type="number"
              fullWidth
              value={allocationQty}
              onChange={(e) => setAllocationQty(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="select-shop-label">Allocate To</InputLabel>
              <Select
                labelId="select-shop-label"
                value={targetShop}
                label="Allocate To"
                onChange={(e) => setTargetShop(e.target.value)}
              >
                <MenuItem value="shop2">Kalawana Shop</MenuItem>
                <MenuItem value="shop3">Pelmadulla Shop</MenuItem>
                <MenuItem value="shop4">Ratnapura Shop</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={handleAllocation}
          disabled={loading}
        >
          {loading ? (
            <BeatLoader color="#ffffff" size={10} />
          ) : (
            'Allocate Stock'
          )}
        </Button>
      </TabPanel>

      {/* Return Stock Modal */}
      <Dialog
        open={returnModalOpen}
        onClose={handleReturnModalClose}
        aria-labelledby="return-stock-dialog-title"
        aria-describedby="return-stock-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="return-stock-dialog-title">Return Stock to Supplier</DialogTitle>
        <DialogContent>
          {returnSelectedItem && (
            <>
              <DialogContentText id="return-stock-dialog-description" sx={{ mb: 2 }}>
                Please provide the details below to return the stock to the supplier.
              </DialogContentText>
              <Box sx={{ mt: 2 }}>
                {/* Item Details */}
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Item Name:</strong> {returnSelectedItem.itemname}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Available Quantity:</strong> {returnSelectedItem.stock}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Expiration Date:</strong>{' '}
                  {returnSelectedItem.stockexpiredate === '2100-12-31'
                    ? 'No Expiry'
                    : returnSelectedItem.stockexpiredate}
                </Typography>

                {/* Supplier Selection */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel id="select-supplier-label">Select Supplier</InputLabel>
                  <Select
                    labelId="select-supplier-label"
                    value={selectedSupplier}
                    label="Select Supplier"
                    onChange={(e) => setSelectedSupplier(e.target.value)}
                  >
                    {suppliers.map((supplier) => (
                      <MenuItem key={supplier.SupplierID} value={supplier.SupplierID}>
                        {supplier.SupplierName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Quantity to Return */}
                <TextField
                  label="Quantity to Return"
                  type="number"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={returnQty}
                  onChange={handleReturnQtyChange}
                  inputProps={{
                    min: 1,
                    max: returnSelectedItem.stock,
                  }}
                  helperText={`Enter a value between 1 and ${returnSelectedItem.stock}`}
                />


              <TextField
                  label="Selling Price (Rs.)"
                  type="number"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={unitPrice}
                  onChange={handleSellingPriceChange}
                  inputProps={{
                    min: 0,
                    step: '0.01',
                  }}
                  helperText="Enter the selling price per unit."
                />


                {/* Total Return Value */}
                <Typography variant="h6" sx={{ mt: 2 }}>
                  Total Return Value: {unitPrice > 0 ? `Rs. ${totalReturn.toFixed(2)}` : 'Calculating...'}
                </Typography>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReturnModalClose} color="primary" disabled={returnLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmReturn}
            color="secondary"
            variant="contained"
            disabled={returnLoading || !selectedSupplier || returnQty < 1}
          >
            {returnLoading ? <BeatLoader color="#ffffff" size={10} /> : 'Confirm Return'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Return Stock Modal */}
      <Dialog
        open={EditModalOpen}
        onClose={handleEditModalClose}
        aria-labelledby="return-stock-dialog-title"
        aria-describedby="return-stock-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="return-stock-dialog-title">Edit Stock</DialogTitle>
        <DialogContent>
          {EditSelectedItem && (
            <>
              <DialogContentText id="return-stock-dialog-description" sx={{ mb: 2 }}>
                Please provide the details below to Edit the Stock.
              </DialogContentText>
              <Box sx={{ mt: 2 }}>
                {/* Item Details */}
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Item Name:</strong> {EditSelectedItem.itemname}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Available Quantity:</strong> {EditSelectedItem.stock}
                </Typography>
                

            
                {/* Quantity to Return */}
                <TextField
                  label="New Qty"
                  type="number"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={editQty}
                  onChange={handleEditQtyChange}
                 
                />
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditModalClose} color="primary" disabled={EditLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmEdit}
            color="secondary"
            variant="contained"
            disabled={ !editQty }
          >
            {EditLoading ? <BeatLoader color="#ffffff" size={10} /> : 'Edit Stock'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Snackbar */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleAlertClose} severity={alertSeverity} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default StockAllocation;
